import React from 'react';
import { motion } from 'framer-motion';

const TURRIS_LOGO = '/logo-turris.svg';

export default function LoadingScreen({ message }) {
  return (
    <div 
      className="min-h-screen flex flex-col items-center justify-center px-6"
      style={{ backgroundColor: '#FDFBF7' }}
    >
      <motion.img
        src={TURRIS_LOGO}
        alt="Turris"
        className="h-16 mb-8"
        animate={{ opacity: [0.5, 1, 0.5] }}
        transition={{ duration: 2, repeat: Infinity }}
      />
      
      {/* Spinner */}
      <motion.div
        className="w-16 h-16 rounded-full border-4 mb-6"
        style={{ 
          borderColor: '#F6F0E4',
          borderTopColor: '#D32F2F'
        }}
        animate={{ rotate: 360 }}
        transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
      />
      
      {/* Message */}
      <motion.p
        className="text-lg text-center font-medium"
        style={{ color: '#2B2B2B' }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        {message || 'Cargando...'}
      </motion.p>
      
      {/* Decorative dots */}
      <div className="flex gap-2 mt-4">
        {[0, 1, 2].map((i) => (
          <motion.div
            key={i}
            className="w-2 h-2 rounded-full"
            style={{ backgroundColor: '#F4A261' }}
            animate={{ y: [0, -8, 0] }}
            transition={{ 
              duration: 0.6, 
              repeat: Infinity, 
              delay: i * 0.2 
            }}
          />
        ))}
      </div>
    </div>
  );
}
